var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.663,
    height: 23.663,
    viewBox: "0 0 23.663 23.663",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10008",
    "data-name": "Path 10008",
    d: "M26.274,24.408l-4.468-4.455a10.408,10.408,0,0,0,2.221-6.439A10.513,10.513,0,1,0,13.513,24.027a10.408,10.408,0,0,0,6.439-2.221l4.455,4.468a1.32,1.32,0,1,0,1.866-1.866ZM5.628,13.513A7.885,7.885,0,1,1,13.513,21.4a7.885,7.885,0,0,1-7.885-7.885Z",
    transform: "translate(-3 -3)",
    fill: "#152c40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.0b1f1d4c39dec05d2be5e71e268c239a.svg";
export { ForwardRef as ReactComponent };